export const REASON_CANCEL = [
    {
        name: 'Sellers Request',
        value: 'Sellers Request',
    },
    {
        name: 'Mapping sai',
        value: 'Mapping sai',
    },
    {
        name: 'Đổi type, size',
        value: 'Đổi type, size',
    },
    {
        name: 'Sai Design',
        value: 'Sai Design',
    },
    {
        name: 'Lý do khác:',
        value: 'other',
    },
]